export default __webpack_public_path__ + "static/media/Astu.82911152.png";